import { request } from '@libs/index';

export namespace nsKdevKimUser {
    export interface IParams {
    }

    export interface IReturn_item {
        path: string[];
        name: string;
        userName: string;
        avatar: string;
        groupId?: string;
        service?: string; // 服务号的kim链接
        appKey?: string; // open api appKey
        secretKey?: string; // open api secretKey
        inviteUserName?: string; // 邀请机器人入群（一般为群主）
    }
    export interface IReturn {
        oncallList: Array<IReturn_item>;
        errorOncallList: Array<IReturn_item>;
    }
    // 获取oncall列表
    export const remote = async (params: IParams): Promise<IReturn> => {
        return request.get('/api/kdev/kconf/oncall/list', params)
                      .then((result: any) => result || { result: [] });
    };
}
